import { render, staticRenderFns } from "./VeTextBlockSettings.vue?vue&type=template&id=4c173811"
import script from "./VeTextBlockSettings.vue?vue&type=script&lang=js"
export * from "./VeTextBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports